import { useTranslation } from "react-i18next";
import { stepState } from "../../../recoil";
import { useRecoilValue } from "recoil";
import { FormDateTimePicker } from "../../../../../components/fields";
import { IFormValues, InsertBookingStep } from "../../../types";
import { useMemo } from "react";
import dayjs from "dayjs";
import { useFormContext } from "react-hook-form";

const FormBookingDateTime = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);
    const currentDate = useMemo(() => dayjs(), []);
    const { trigger, getValues } = useFormContext<IFormValues>();

    const handleChange = () => {
        const bookingDateTime = getValues("basicDetails.bookingDateTime");
        if(!bookingDateTime || (!!bookingDateTime && bookingDateTime.isValid()))
            trigger('basicDetails.pickupDate');
    }

    return (
        <FormDateTimePicker<IFormValues>
            name="basicDetails.bookingDateTime"
            label={t('label.bookingDateTime')}
            onChange={handleChange}
            maxDateTime={currentDate}
            disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
        />
    );

}

export default FormBookingDateTime;